import React from "react";
import { Route, Switch } from "react-router-dom";

import asyncComponent from "../util/asyncComponent";
import Components from "./components/index";

const App = ({ match }) => (
  <div className="gx-main-content-wrapper">
    <Switch>
      <Route
        path={`${match.url}sample`}
        component={asyncComponent(() => import("./SamplePage"))}
      />
      <Route path={`${match.url}data`} component={Components} />
    </Switch>
  </div>
);

export default App;
